import '.bq{flex-shrink:0;}.ssr-plugin'
import '.bs{padding:1rem;}.ssr-plugin'
import '.a6{width:100%;}.ssr-plugin'
import '.as{height:100%;}.ssr-plugin'
import '.b7{border:none;}.ssr-plugin'
import '.b8{background-color:transparent;}.ssr-plugin'
import '.fh{border-radius:0px;}.ssr-plugin'
import '.g{display:flex;}.ssr-plugin'
import '.k{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.d9{position:sticky;}.ssr-plugin'
import '.fi{top:4rem;}.ssr-plugin'
import '.fj{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.fk{padding-bottom:1rem;}.ssr-plugin'
import '.o{margin-bottom:1rem;}.ssr-plugin'
import '.fl{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a1{position:fixed;}.ssr-plugin'
import '.co{top:0;}.ssr-plugin'
import '.aq{left:0px;}.ssr-plugin'
import '.ar{right:0px;}.ssr-plugin'
import '.fm{bottom:0px;}.ssr-plugin'
import '.ew{z-index:9999;}.ssr-plugin'
import '.fn{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.d3{justify-content:flex-end;}.ssr-plugin'
import '.c6{flex:1;}.ssr-plugin'
import '.af{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bq bs a6 as b7 b8 fh"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="g k ab"
    >
      <div className="d9 fi fj ae fk o fl g"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a1 co aq ar fm ew ae fn g k"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bs g d3 fl"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c6 af">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
